import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  InjectionToken,
  Input,
  Optional,
} from '@angular/core';
import { Renderable, RenderableConfig } from '../app.models';

export const HEADER_TOKEN = new InjectionToken<HeaderConfig>(
  'to content data into header component'
);

export interface HeaderConfig extends RenderableConfig {
  text?: string;
  size?: 1 | 2 | 3;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderComponent implements Renderable {
  private _config: HeaderConfig;
  @Input() public set config(config: HeaderConfig) {
    this._config = config;
  }
  public get config() {
    return this._config;
  }

  constructor(
    @Optional() @Inject(HEADER_TOKEN) private _injectedConfig: HeaderConfig
  ) {
    this._config = this._injectedConfig;
  }
}
